import cn from 'clsx';

import { IconProps } from './types';

export const LinkIcon: React.FC<IconProps> = ({
  className,
  strokeWidth = 2,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18.843"
    height="18.843"
    viewBox="0 0 18.843 18.843"
    className={cn('h-6 w-6', className)}
  >
    <g id="link" transform="translate(0 0)">
      <g id="Group_201" data-name="Group 201" transform="translate(6.336 0)">
        <g id="Group_200" data-name="Group 200">
          <path
            id="Path_2476"
            data-name="Path 2476"
            d="M183.373,1.293a4.416,4.416,0,0,0-6.246,0l-3.691,3.691a4.458,4.458,0,0,0,0,6.246,4.2,4.2,0,0,0,.888.674L175,11.23a1.517,1.517,0,0,0,.278-1.331,2.132,2.132,0,0,1-.278-.23,2.232,2.232,0,0,1,0-3.123l3.691-3.691a2.208,2.208,0,0,1,3.123,3.123l-2.44,2.44a6.356,6.356,0,0,1,.276,2.84c.011-.01.023-.017.034-.028l3.691-3.691A4.416,4.416,0,0,0,183.373,1.293Z"
            transform="translate(-172.159 0)"
            fill="currentColor"
          />
        </g>
      </g>
      <g id="Group_203" data-name="Group 203" transform="translate(0 6.653)">
        <g id="Group_202" data-name="Group 202" transform="translate(0)">
          <path
            id="Path_2477"
            data-name="Path 2477"
            d="M11.517,181.45a4.2,4.2,0,0,0-.888-.674l-.674.674a1.517,1.517,0,0,0-.278,1.331,2.126,2.126,0,0,1,.278.23,2.232,2.232,0,0,1,0,3.123l-3.977,3.977a2.208,2.208,0,1,1-3.123-3.123l2.726-2.726a6.355,6.355,0,0,1-.276-2.84c-.011.01-.023.017-.034.028l-3.977,3.977a4.416,4.416,0,1,0,6.246,6.246l3.977-3.977A4.456,4.456,0,0,0,11.517,181.45Z"
            transform="translate(0 -180.776)"
            fill="currentColor"
          />
        </g>
      </g>
    </g>
  </svg>
);
